import { Map, fromJS } from 'immutable';

export function request(state, { marketId, params, templateId }) {
    return state.set(
        'add-selection',
        (state.get('add-selection') || Map())
            .set(marketId, Map({
                selection: fromJS({
                    params,
                    templateId
                }),
                state: 'IN_PROGRESS'
            }))
    );
}

export function error(state, { marketId, errors }) {
    return state.set(
        'add-selection',
        (state.get('add-selection') || Map())
            .set(marketId, Map({
                selection: state.getIn([ 'add-selection', marketId, 'selection' ]),
                state: 'ERROR',
                errors: fromJS(errors)
            }))
    );
}

export function finish(state, { marketId, market }) {
    return state
        .set(
            'add-selection',
            (state.get('add-selection') || Map())
                .set(marketId, Map({
                    selection: state.getIn([ 'add-selection', marketId, 'selection' ]),
                    state: 'FINISHED'
                }))
        )
        .mergeIn([ 'items', marketId ]);
}
